import { isoDayToUtcDate, plusUtcDays, utcDayToLocalDate } from "@/utils/dates";

import { createApiClient } from "./apiClient";

export class LicenseService {
  constructor(authAPIUrl) {
    this.apiClient = createApiClient(authAPIUrl, "v1/license");
  }

  async getLicense() {
    const data = await this.apiClient.get();
    const expiryDate = expiryOf(data);
    return {
      expiryDate,
      lastValidDay: utcDayToLocalDate(plusUtcDays(expiryDate, -1)),
      isValid: data.is_valid,
      limitedExternalSwimlanes: data.limited_external_swimlanes,
      limitedExternalTeams: data.limited_external_teams,
      numberOfTeams: data.number_of_teams,
      onprem: data.onprem,
      plan: data.plan,
      sso: data.sso,
      tracking: data.tracking,
      type: data.type,
      usedTeamLicenses: data.used_team_licenses,
    };
  }

  async getOnPremKey() {
    const res = await this.apiClient.get("onprem-key");
    return res.key;
  }

  async updateOnPremKey(key) {
    return this.apiClient.patch("onprem-key", { key });
  }
}

function expiryOf(data) {
  const expiryDate = plusUtcDays(isoDayToUtcDate(data.expiry_date), 1);
  const now = new Date();
  // if server says is_expired, then overwrite the expiry date
  return data.is_expired && expiryDate > now ? now : expiryDate;
}
